import React from "react";
import { Typography, MenuItem } from "@mui/material";
import { Styled } from "./styles";
import { i18n } from "@/utils/i18n";
import { useFormContext } from "react-hook-form";
import { Forms } from "@/types/form";

interface StatusFieldProps {
    variant: "incomings" | "outgoings";
    index: number;
}

const StatusField: React.FC<StatusFieldProps> = ({ variant, index }) => {
    const { register, watch } = useFormContext<Forms["Category"]>();
    const value = watch(`${variant}.${index}.status`);

    return (
        <Styled.FormControl>
            <Styled.Select
                {...register(`${variant}.${index}.status`)}
                value={value ?? 0}
                variant="standard"
                disableUnderline
                renderValue={selectedValue => {
                    if (selectedValue === 1) {
                        return (
                            <Typography color="primary" sx={{ fontSize: "22px" }}>
                                &#10004;
                            </Typography>
                        );
                    }
                    if (selectedValue === 2) {
                        return (
                            <Typography
                                color="primary"
                                sx={{ fontSize: "22px", ":after": { content: '"*"' } }}
                            >
                                &#10004;
                            </Typography>
                        );
                    }
                    if (selectedValue === 3) {
                        return (
                            <Typography color="primary" sx={{ fontSize: "34px" }}>
                                &#8764;
                            </Typography>
                        );
                    }
                    return (
                        <Typography color="primary" sx={{ fontSize: "34px" }}>
                            &#8722;
                        </Typography>
                    );
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            fontSize: "0.8rem",
                        },
                    },
                }}
            >
                {[0, 1, 2, 3].map(key => (
                    <MenuItem key={key} value={key} sx={{ fontSize: "0.8rem" }}>
                        <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            {i18n.t(`categoryStatus.${key}`)}
                        </Typography>
                    </MenuItem>
                ))}
            </Styled.Select>
        </Styled.FormControl>
    );
};

export default StatusField;
